<template>
  <loading v-if="!langLoaded" class="route_loading"></loading>
  <login v-if="!authenticated && langLoaded"></login>
  <div id="app" v-if="langLoaded" v-else>
    <navigation></navigation>
    <route-header></route-header>
    <loading v-if="loading" class="route_loading"></loading>
    <router-view class="view" :class="{'loading': loading}" transition transition-mode="out-in"></router-view>
  </div>
  <site-footer v-if="langLoaded"></site-footer>
  <impersonation v-if="showModal && langLoaded"></impersonation>
  <file-saver v-if="langLoaded"></file-saver>
  <sent-popup></sent-popup>
</template>

<script>
  import store from "./vuex/store";
  import Impersonation from "./views/impersonation/Impersonation";
  import RouteHeader from "./shared/RouteHeader";
  import Loading from "./shared/Loading";
  import SiteFooter from "./app/site-footer/SiteFooter";
  import Navigation from "./app/navigation/Navigation";
  import Login from "./views/login/Login";
  import FileSaver from "./app/filesaver/FileSaver";
  import SentPopup from "./shared/SentPopup";

  import { getResources, scrollChanged, checkLogged, setCulture } from "./AppActions";

  export default {
    store,
    replace: false,
    components: { SiteFooter, Navigation, Login, RouteHeader, Loading, Impersonation, FileSaver, SentPopup },
    vuex: {
      getters: {
        authenticated: state => state.authenticated,
        loading: state => state.loading,
        scrolled: state => state.scrolled,
        downloadURL: state => state.downloadURL,
        resources: state => state.resources,
        langLoaded: state => state.langLoaded,
        culture: state => state.currentCulture,
        showModal: state => state.showModal,
        access_token: state => state.access_token
      },
      actions: { getResources, scrollChanged, checkLogged, setCulture }
    },
    mounted () {
      const otAutoBlock = document.createElement("script");
      otAutoBlock.src = "https://cdn-ukwest.onetrust.com/consent/9688e8f4-65b4-426b-96d9-1a704f89b149-test/OtAutoBlock.js";
      otAutoBlock.type = "text/javascript";

      const otSDKStub = document.createElement("script");
      otSDKStub.src = "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js";
      otSDKStub.type = "text/javascript";
      otSDKStub.charset = "UTF-8";
      otSDKStub.setAttribute("data-domain-script', '9688e8f4-65b4-426b-96d9-1a704f89b149-test");

      const optanonWrapper = document.createElement("script");
      optanonWrapper.type = "text/javascript";
      optanonWrapper.textContent = "function OptanonWrapper() { }";

      document.head.appendChild(otAutoBlock);
      document.head.appendChild(otSDKStub);
      document.head.appendChild(optanonWrapper);
    },
    ready () {
      window.onscroll = this.scrollChanged;
      this.setCulture();
      this.getResources(this.culture);
      this.checkLogged();
    },
    methods: {
      scrollChanged (event) {
        store.dispatch("SCROLLED", window.pageYOffset);
      }
    }
  };
</script>

<style lang="scss">
  @import './assets/scss/general.scss';

  #app {
    margin: 0px;
    overflow: hidden;
  }

  .view {
    transition: opacity .25s;

    &.v-enter, &.v-leave, &.loading {
      opacity: 0;
    }

    &.loading {
      height: 0;
      overflow: hidden;
    }
  }

  .route_loading {
    max-width: 1120px;
    margin: 100px auto;
    height: 410px;
  }
</style>




// WEBPACK FOOTER //
// app.vue?19a0e068